import axiosInstance from '../utils/AxiosConfig';

export const isCashRegisterOpen = async (locationId, terminalId) => {
  const response = await axiosInstance.get(`/cash_register/is_open`, {
    params: {
      locationId: locationId,
      terminalCode: terminalId
    }
  });
  return response.data.data;
};

export const openCashRegister = async (data) => {
  const response = await axiosInstance.post('/cash_register/open', data);
  return response.data;
};

export const closeCashRegister = async (data) => {
  const response = await axiosInstance.post('/cash_register/close', data);
  return response.data.data;
};

export const getCashRegisterClosePreflight = async (locationId) => {
  const response = await axiosInstance.get('/cash_register/close_preflight', {
    params: { locationId },
  });
  return response.data.data;
};

export const getLastCloseCashRegister = async (locationId, terminalId) => {
  const response = await axiosInstance.get(`/cash_register/last_close`, {
      params: { locationId, terminalCode: terminalId }
  });
  return response.data.data;
};

export const getLastOpenCashRegister = async (locationId, terminalId) => {
  const response = await axiosInstance.get(`/cash_register/last_open`, {
      params: { locationId, terminalCode: terminalId }
  });
  return response.data.data;
};

export const getOpenAndCloseCash = async (page = 1, pageSize = 10, searchTerm = '', options = {}) => {
  const params = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString()
  });
  
  if (searchTerm && typeof searchTerm === 'string' && searchTerm.trim()) {
    params.append('search', searchTerm.trim());
  }
  if (options.sortField) params.append('sortField', options.sortField);
  if (options.sortDirection) params.append('sortDirection', options.sortDirection);
  if (options.filterField) params.append('filterField', options.filterField);
  if (options.filterOperator) params.append('filterOperator', options.filterOperator);
  if (options.filterValue !== undefined && options.filterValue !== null && options.filterValue !== '') {
    params.append('filterValue', options.filterValue.toString());
  }
  
  const response = await axiosInstance.get(`/cash_register?${params}`);
  return response.data.data;
};

export const getOpenAndCloseCashByUser = async (page = 1, pageSize = 10, searchTerm = '', options = {}) => {
  const params = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString()
  });
  
  if (searchTerm && typeof searchTerm === 'string' && searchTerm.trim()) {
    params.append('search', searchTerm.trim());
  }
  if (options.sortField) params.append('sortField', options.sortField);
  if (options.sortDirection) params.append('sortDirection', options.sortDirection);
  if (options.filterField) params.append('filterField', options.filterField);
  if (options.filterOperator) params.append('filterOperator', options.filterOperator);
  if (options.filterValue !== undefined && options.filterValue !== null && options.filterValue !== '') {
    params.append('filterValue', options.filterValue.toString());
  }
  
  const response = await axiosInstance.get(`/cash_register/by_user?${params}`);
  return response.data.data;
};

export const insertMovement = async (data) => {
  const response = await axiosInstance.post(`/cash_register/movement`, data);
  return response.data.data;
};

// Cierra el lote del POS antes de cerrar la caja; devuelve { status, lot, approved, message, totals, system_pos }. Puede tardar unos
// segundos porque espera la respuesta del POS.
export const closeCashRegisterBatch = async (data) => {
  const response = await axiosInstance.post('/cash_register/close_batch', data, { timeout: 60000 });
  return response.data.data;
};
